// extracted by mini-css-extract-plugin
export default {"cities":"Cities_cities__pgbx3","wrapper":"Cities_wrapper__B+Q9l","cities_list":"Cities_cities_list__SPACC","menu_active":"Cities_menu_active__QL8MO"};